export const isNoBannerPost = (post: any) => {
  if (post && post.tags && post.tags.nodes) {
    const tagArray = post.tags.nodes;
    const noBannerTag = tagArray.filter((tag: any) => tag.slug === 'nobanner');
    return noBannerTag.length > 0;
  }

  return false;
};
